import { render, staticRenderFns } from "./TheTableCategories.vue?vue&type=template&id=04f32429&scoped=true&"
import script from "./TheTableCategories.vue?vue&type=script&lang=ts&"
export * from "./TheTableCategories.vue?vue&type=script&lang=ts&"
import style0 from "./TheTableCategories.vue?vue&type=style&index=0&id=04f32429&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f32429",
  null
  
)

export default component.exports